import type { PagesMessages } from './pages';

export const zhPages: PagesMessages = {
  common: {
    cancel: '取消',
    save: '保存',
    view: '查看',
    loading: '加载中...',
    delete: '删除',
    edit: '编辑',
    refresh: '刷新',
    close: '关闭',
    all: '全部',
    newest: '最新',
    oldest: '最早',
    newestShort: '新',
    oldestShort: '旧',
    fromDate: '开始日期',
    toDate: '结束日期',
    sortBy: '排序',
    updating: '更新中...',
    saving: '保存中...',
    update: '更新',
    create: '创建',
    add: '添加',
    copy: '复制',
    purgedOldGalleries: '已删除 {n} 个超过 1 年的图库',
  },
  mPhotoPro: {
    title: 'M-Photo Pro',
    subtitle: 'Pro 桌面应用的图库与自定义相框',
    noAccess: '此账户无权使用 M-Photo Pro。',
    tabs: { photos: '照片', customFrames: '自定义相框', customFramesShort: '相框', themes: '主题', themesShort: '主题', collections: '合集', icons: '图标', stats: '统计' },
  },
  colorApps: {
    title: '应用配色',
    titleAll: '应用配色 — 全部设备',
    titleMachine: '应用配色 — 此设备',
    description: '选择主色。应用会使用浅色配色（背景、边框、柔和色等），与机器上的取色器相同。',
    descriptionAll: '更改此账户下所有设备的应用强调色。仍可在每台机器的应用配色页单独设置。',
    descriptionMachine: '只更改此设备的应用强调色。账户中的其他机器保持各自的颜色。',
    hexLabel: '颜色代码（hex）',
    pickColor: '选择颜色',
    hexHelper: '例如：#d45d7f — 按 Enter 或应用以保存',
    apply: '应用',
    presets: '推荐颜色',
    derivedPalette: '应用色板（派生色板）',
    preview: '界面预览',
    primaryBtn: '主按钮',
    secondaryBtn: '次按钮',
    badgeChip: '徽章 / 标签',
    loadError: '无法加载应用颜色',
    saveSuccess: '应用颜色已保存',
    saveSuccessAll: '已为所有设备保存应用颜色',
    saveSuccessMachine: '已为此设备保存应用颜色',
    saveError: '保存颜色失败',
    invalidHex: '颜色代码无效（#RRGGBB）',
    slots: {
      bg: '背景',
      surface: '表面',
      border: '边框',
      soft: '柔和',
      primary: '主色',
      hover: '悬停',
      text: '文字',
    },
  },
  photoboothSimple: {
    title: '拍照亭',
    titleMachine: '拍照亭',
    descriptionMachine: '开启后，此机器会显示拍摄二维码。',
    toggleLabel: '简易模式',
    toggleOnHint: '开',
    toggleOffHint: '关',
    maxAccessLabel: '每日打印次数',
    maxAccessHint: '0 = 不限',
    maxAccessSaveSuccess: '已更新设备每日限额',
    captureIdleLabel: '拍摄空闲超时',
    captureIdleHint: '拍摄画面空闲后自动返回首页（1–10 分钟）',
    previewIdleLabel: '预览空闲超时',
    previewIdleHint: '预览画面空闲后自动打印或返回首页（1–10 分钟）',
    retakeToggleLabel: '在简易 HTML 中显示重拍',
    retakeToggleHint: '客人可在打印前重拍单个照片位',
    retakeEnableSuccess: '已在简易 HTML 中开启重拍按钮',
    retakeDisableSuccess: '已在简易 HTML 中隐藏重拍按钮',
    idleTimeoutSaveSuccess: '空闲超时已更新',
    idleTimeoutUnit: '分钟',
    captureCountdownLabel: '拍摄倒计时',
    captureCountdownHint: '每次拍摄前的秒数（1–30）。+/− 会立即更新机器，与控制页相同，不保存到服务器。',
    captureCountdownUnit: '秒',
    captureCountdownSaveSuccess: '拍摄倒计时已发送到机器',
    captureCountdownOffline: '机器离线 — 请先连接应用再更改倒计时',
    lastUpdated: '最后更新：{date}',
    loadError: '无法加载拍照亭简易模式',
    enableSuccess: '已为此设备开启简易模式',
    disableSuccess: '已为此设备关闭简易模式',
    saveError: '更新简易模式失败',
    missingMachine: '缺少机器代码',
    accessCodeTitle: '访问码（3 个字符）',
    accessCodeHint: '客人打开二维码链接后输入此代码。空闲时每 3 分钟更换一次。',
    accessCodeUpdated: '代码更新时间：{date}',
    sessionInUse: '当前有人正在使用此拍照亭会话。',
    qrTitle: '拍摄二维码',
    qrHint: '扫码打开此机器的拍照页（仍需访问码）。',
    copyLink: '复制链接',
    openLink: '打开链接',
  },
  mPhotoLite: {
    title: 'M-Photo Lite',
    subtitle: 'Android 应用的图库服务器、自定义相框和 PNG 图标',
    tabs: { gallery: '照片', customFrames: '自定义相框', customFramesShort: '相框', themes: '主题', themesShort: '主题', icons: '图标', stats: '统计' },
    galleryEmpty: '还没有来自 M-Photo Lite 的图库。',
    iconsDisabled: '未开启设备管理 — 无法管理图标。',
  },
  mPhotoMono: {
    title: 'M-Photo Mono',
    tabs: { subPhotos: '副照片', frames: '添加相框', photos: '照片', stats: '统计' },
    dropActive: '把照片拖到这里',
    dropIdle: '拖放照片，或点击选择',
    photosHint: '从 Mono 应用同步到服务器的图库。',
    totalFiltered: '共 {n} 个符合筛选的图库',
    total: '共 {n} 个图库',
    photoCount: '{n} 张照片 · {p} 次打印',
    endOfList: '已显示全部 {shown}/{total} 个图库',
    emptyFiltered: '没有符合筛选的图库',
    empty: '还没有来自 M-Photo Mono 的图库',
  },
  photos: {
    viewTabs: { groups: '分组', list: '列表', collections: '合集' },
    selectAll: '全选',
    downloadSelected: '下载（{n} 组）',
    downloading: '下载中...',
    addToCollection: '加入合集',
    dropActive: '把照片拖到这里',
    dropIdle: '把照片拖到这里，或点击选择',
    maxFiles: '一次最多 10 张照片',
    uploadCta: '添加照片',
    filterByDate: '日期筛选',
    filterByDevice: '设备',
    allDevices: '全部设备',
    clearFilter: '清除',
  },
  customFrames: {
    titlePro: '自定义相框 — M-Photo Pro',
    titleLite: '自定义相框 — M-Photo Lite',
    titleMono: '自定义相框 — M-Photo Mono',
    hintPro: '管理员已为 M-Photo Pro 应用开启的相框。',
    hintLite: '管理员已为 M-Photo Lite 开启的相框。',
    emptyGranted: '管理员尚未授予任何自定义相框。',
    emptyEnabled: '管理员尚未开启任何自定义相框。',
    filterSize: '按尺寸筛选',
    viewUserFrames: '查看用户相框',
    toggleOn: '已开启 — 点击关闭',
    toggleOff: '已关闭 — 点击开启',
  },
  livePhotos: {
    title: '实况照片',
    loginRequired: '请登录后选择合集并查看实况照片。',
    emptyCollections: '你还没有合集。',
    selectCollection: '在左侧选择一个合集以开始实况查看。',
    emptyGallery: '此合集还没有图库。',
    galleryLabel: '图库：',
    uploadedAt: '上传时间：{datetime}',
    collectionListTitle: '合集列表',
    galleryListTitle: '图库列表',
  },
  videos: {
    title: '我的视频',
    dropActive: '把视频拖到这里',
    dropIdle: '把视频拖到这里，或点击选择',
    maxOne: '一次最多 1 个视频',
    created: '创建时间：{date}',
  },
  sePay: {
    title: 'SePay 支付',
    subtitle: '配置支付网关和打印价格',
    tabs: { config: 'SePay 配置', price: '4×6 打印价格', device: '设备' },
    webhookTitle: 'Webhook 地址',
    webhookHint: '粘贴到 SePay 控制台 → Webhooks → 创建 webhook',
    receivingAccount: '收款账户',
    linked: '已绑定 — 点击更换',
    noAccount: '未选择账户',
    tapToConfig: '点击配置',
    saveKeysHeading: '保存 SePay 网关密钥',
    apiTokenLabel: 'API Token',
    priceLabel: '每张 4×6 打印价格（越南盾）',
    savePrice: '保存价格',
    clearInput: '清空输入',
    deviceHeading: '按机器管理设备',
    deviceHint: '开启“需要 SePay 二维码”后，机器必须先扫码才能打印。',
    liteRequireQr: 'M-Photo Lite — 需要 SePay 二维码',
    proRequireQr: 'M-Photo Pro — 需要 SePay 二维码',
    createQrTitle: '创建支付二维码（VietQR）',
    amount: '金额（越南盾）',
    description: '说明',
    bank: '银行',
    va: '虚拟账户（VA）*',
    passwordDialog: '确认密码',
    qrDialog: '扫码转账',
  },
  events: {
    title: '活动管理',
    createNew: '创建新活动',
    empty: '你还没有活动。创建第一个活动吧！',
    code: '代码：{code}',
    dialogCreate: '创建新活动',
    dialogUpdate: '更新活动',
    nameLabel: '活动名称',
    namePlaceholder: '例如：2025 春节活动',
    submitCreate: '创建',
    submitUpdate: '更新',
    confirmDelete: '确定删除活动“{name}”吗？',
  },
  profile: {
    title: '个人信息',
    loading: '正在加载用户信息...',
    changeBackground: '更换背景',
    changeAvatar: '更换头像',
    basicInfo: '基本信息',
    username: '用户名',
    email: '邮箱',
    passwordSection: '修改密码（可选）',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    submit: '更新资料',
    submitting: '更新中...',
  },
  themes: {
    title: '主题管理',
    createNew: '创建新主题',
    customFrameList: '自定义相框列表',
    proShowAllTitle: '显示全部自定义相框（M-Photo Pro）',
    proShowAllHint: '开启：Pro 机器显示所有版式。关闭：只显示当前主题中的版式。',
    emptyTitle: '还没有主题',
    emptyHint: '创建第一个主题，为 M-Photo Pro 整理相框。',
    emptyHintLite: '在这里为 M-Photo Lite 创建主题，与 Pro 主题分开。',
    active: '启用',
    inactive: '停用',
    activeMliteLabel: '拍摄',
    mobileUploadProTitle: '手机上传',
    mobileUploadProHint: '与 Lite 分开 — 仅当 Pro 打开手机上传 HTML 时。',
    mobileUploadLiteTitle: '手机上传（Lite）',
    mobileUploadLiteHint: '与 Pro 分开 — 仅当 M-Photo Lite 打开手机上传 HTML 时。',
    mobileUploadOtherStatus: '其他通道：{status}',
    scheduleOpen: '设置',
    scheduleTitle: '设置',
    scheduleHint: '开启后，此主题只在开始和结束时间之间生效。',
    scheduleEnable: '仅在时间段内',
    scheduleFrom: '从',
    scheduleUntil: '到',
    machineFilterEnable: 'Pro 机器',
    machineFilterEnableLite: 'Android 机器',
    machineFilterSelectAll: '全选',
    machineFilterClearAll: '全部清除',
    machineFilterHint: '只有勾选的 Pro 机器会使用此主题。如果都不勾选，则不应用到任何机器。',
    machineFilterHintLite: '只有勾选的 Android 机器（M-Photo Lite）会使用此主题。如果都不勾选，则不应用到任何机器。',
    machineFilterNeedFrame: '请先添加相框，再筛选机器。',
    machineFilterEmpty: '此账户还没有 Pro 机器。',
    machineFilterEmptyLite: '此账户还没有 Android 机器。',
    machineFilterLoading: '正在加载机器...',
    machineFilterButton: '筛选机器',
    machineFilterSaved: '机器筛选已保存',
    machineFilterSaveFail: '无法保存机器筛选',
    scheduleAlways: '任意时间',
    scheduleAllMachines: '全部机器',
    scheduleNoMachines: '没有机器',
    scheduleMachineCount: '{n} 台机器',
    scheduleOutside: '不在时间段内',
    dialogCreate: '创建新主题',
    dialogEdit: '更新主题',
    name: '主题名称',
    description: '说明',
    tags: '标签（逗号分隔）',
    imageOptional: '主题图片（可选）',
    dropImage: '点击选择图片，或拖放到这里',
    imageFormats: 'PNG、JPG、JPEG（最大 10MB）',
    breadcrumb: '主题',
    noDescription: '没有说明',
    metaCounts: '{n} 个自定义相框 • {m} 个用户相框',
    addCustomFrame: '添加自定义相框',
    framesInTheme: '主题中的自定义相框',
    emptyFramesTitle: '还没有自定义相框',
    emptyFramesHint: '点击“添加自定义相框”把相框加入此主题',
    addDialogTitle: '向主题添加自定义相框',
    addDialogHint: '只显示已为 M-Photo Pro 开启的自定义相框。',
    addDialogHintLite: '只显示已为 M-Photo Lite 开启的自定义相框。',
    noLiteFrames: '还没有为 Lite 开启的自定义相框。',
    pickUserFramesTitle: '选择用户相框',
    pickUserFramesHint: '选择此自定义相框的用户相框以加入主题。',
    pickUserFramesUpload: '上传用户相框',
    pickUserFramesUploadHint: 'PNG、JPG。最多 10 个文件，每个 5MB。',
    pickUserFramesUploading: '正在上传用户相框...',
    pickUserFramesEmpty: '此自定义相框还没有用户相框。',
    pickUserFramesAdd: '添加 {n} 个用户相框',
    pickUserFramesAddFrame: '只添加相框',
    searchPlaceholder: '按名称或尺寸搜索...',
    filterByRatio: '按宽高比筛选',
    noProFrames: '还没有为 Pro 开启的自定义相框。',
    allAddedOrFiltered: '所有相框都已在主题中，或不符合筛选',
    notFound: '未找到主题',
  },
  customerInfo: {
    title: '客户信息',
    subtitle: '管理客户信息和合集设置',
    settingTitle: '信息收集设置',
    enabled: '开启 — 客户查看图库时必须填写信息',
    disabled: '关闭 — 客户查看图库时不必填写信息',
    listTitle: '客户列表（{total}）',
    export: '导出客户信息',
    empty: '还没有客户信息',
    endMessage: '已显示全部 {total} 位客户',
    colImage: '照片',
    colEmail: '邮箱',
    colName: '姓名',
    colActions: '操作',
    noImage: '没有照片',
    editDialog: '编辑客户信息',
    confirmDelete: '确定删除此客户信息吗？',
  },
  software: {
    title: '软件',
    latestVersion: '最新版本（{channel}）',
    fileName: '文件名：',
    fileSize: '大小：',
    uploadDate: '上传日期：',
    download: '下载',
    noUpdate: '没有可下载的新版本',
    updateInfo: '更新信息',
  },
  aiCreate: {
    title: '创建 AI 图片',
    subtitle: '先创建 AI 主题，再在主题中添加背景。',
    disabled: '此账户未开启 AI 图片。',
    createTheme: '创建 AI 主题',
    viewUsage: '生成记录',
    usageTheme: '主题',
    usageBackground: '背景',
    editTheme: '编辑 AI 主题',
    themeName: '主题名称',
    description: '说明',
    themeImage: '主题图片',
    noThemes: '还没有 AI 主题。添加背景前请先创建主题。',
    backgrounds: 'AI 背景',
    backgroundCount: '{n} 个 AI 背景',
    emptyBackgrounds: '此主题还没有 AI 背景。',
    createBackground: '创建 AI 背景',
    editBackground: '编辑 AI 背景',
    backgroundName: '背景名称',
    prompt: '提示词',
    tags: '标签',
    tagMale: '男',
    tagFemale: '女',
    tagGroup: '团体',
    tagsRequired: '请至少选择一个标签。',
    image: '图片',
    referenceImage: '参考图（可选）',
    referenceHint: '客户照片是图 1。此参考图是图 2。',
    removeReference: '移除参考图',
    proEnable: 'Pro 机器',
    proHint: 'Pro 应用，以及从 Pro 机器打开的手机上传。',
    liteEnable: 'Lite 机器',
    liteHint: 'Android 应用，以及从 Lite 机器打开的手机上传。',
    machineHint: '只有勾选的机器能看到。都不勾选则不显示。',
    noMachines: '还没有此类型的机器。',
    back: '返回',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    confirmDeleteTheme: '删除此 AI 主题及其全部背景？',
    confirmDeleteBackground: '删除此 AI 背景？',
  },
  deviceMgmt: {
    title: '设备管理',
    subtitle: '选择一台机器以查看随机码，并用手机上传照片',
    emptyTitle: '还没有机器',
    emptyHint: '使用设备管理前请先注册机器',
    machineCode: '机器代码：',
    running: '运行中',
    paused: '已暂停',
    platformWindows: 'Windows',
    platformAndroid: 'Android',
    productLite: 'Lite',
    productMono: 'Mono',
    productPro: 'Pro',
    noQrFeatures: '此 Mono 设备没有手机上传或页面控制二维码。',
    viewAccess: '访问',
    renameTitle: '重命名机器',
    renameSuccess: '机器名称已更新',
    deleteTitle: '删除机器',
    deleteConfirm: '确定删除机器“{code}”吗？此操作无法撤销。',
    deleteSuccess: '机器已删除',
    nameLabel: '机器名称',
    namePlaceholder: '输入新的机器名称',
    back: '返回机器列表',
    backShort: '返回',
    tabs: {
      upload: '手机上传',
      uploadShort: '上传',
      control: '页面控制',
      controlShort: '控制',
      photos: '照片',
      photosShort: '照片',
      edit: '编辑列表',
      editShort: '编辑',
      colorApps: '应用配色',
      colorAppsShort: '配色',
      photobooth: '拍照亭',
      photoboothShort: '亭',
      qrEdit: '编辑二维码',
      qrEditShort: '二维码',
    },
    qrEditor: {
      title: '打印二维码位置',
      hint: '按此机器的版式或相框调整偏移和二维码大小。与 mlite 同步时，以较新的编辑时间为准。',
      frame: '相框',
      layoutDefault: '版式默认',
      userFrames: '用户相框',
      offsetX: '偏移 X',
      offsetY: '偏移 Y',
      size: '二维码大小',
      step: '步进',
      showQr: '在打印件上显示二维码',
      lastEdited: '最后编辑：{date}',
      saveSuccess: '二维码位置已保存',
      saveError: '无法保存二维码位置',
      loadError: '无法加载二维码位置',
      reset: '重置',
    },
    photosFilteredBy: '已按机器 {code} 筛选',
    photosEmptyTitle: '此机器没有照片',
    photosEmptyHint: '没有与机器代码 {code} 匹配的图库',
    photosEnd: '已加载机器 {code} 的全部图库',
    photosLoadError: '无法加载照片',
    photosNoLink: '图库链接不可用',
    photosDeleteTitle: '删除照片组',
    photosDeleteConfirm: '确定删除此照片组吗？此操作无法撤销。',
    photosDeleteSuccess: '照片组已删除',
    photosDeleteError: '无法删除照片组',
    machineCodeLabel: '机器代码',
    randomCodeTitle: '随机码（3 个字符）',
    randomCodeHint: '此代码由 M-Photo Lite 应用每 3 分钟自动刷新',
    lastUpdated: '最后更新：{date}',
    qrUploadTitle: '扫码上传照片的二维码',
    qrUploadHint: '用手机扫描此二维码，打开照片上传页',
    fullCode: '完整代码：',
    copyLink: '复制链接',
    openNewTab: '在新标签页打开',
    controlQrTitle: '机器控制二维码',
    controlQrHint: '用手机扫描此二维码，打开机器控制页',
    editQrTitle: '图库编辑 / 签名二维码',
    editQrHint: '扫码打开此机器上待签名图库的编辑列表',
    link: '链接：',
    notFound: '未找到机器信息',
    limitTitle: '设备访问限制',
    limitHint: '设置每台设备的每日访问次数和最大打印份数。输入 0 表示不限访问。',
    accessLabel: '访问次数',
    accessHint: '0 = 不限 · 每天重置',
    printCopiesLabel: '最大打印份数',
    printCopiesHint: '默认 1 · 最多 10（4×6）',
    uiEnabledTitle: '在机器上显示手机上传',
    uiEnabledHint: '在此机器应用（Lite 和 Pro）上显示或隐藏手机上传按钮 / 二维码。',
    uiEnabledOn: '在机器上可见',
    uiEnabledOff: '在机器上隐藏',
    uiEnabledSaveSuccess: '手机上传显示已更新',
    uiEnabledSaveError: '无法更新手机上传显示',
    uiEnabledLoadError: '无法加载手机上传显示',
    controlUiTitle: '为此用户显示控制',
    controlUiHint: '关闭后，隐藏用户账户的控制标签，以及 mlite 设置中的控制页项目。',
    controlUiSaveSuccess: '控制显示已更新',
    controlUiSaveError: '无法更新控制显示',
    controlUiLoadError: '无法加载控制显示',
    bgRemovalTitle: '去除背景（此机器）',
    bgRemovalHint: '开启后：在此 Pro 机器上显示 AI 去背景开关（默认关闭），并在相框详情中显示背景标签。关闭后：两者都隐藏。',
    bgRemovalSaveSuccess: '已更新此机器的去背景设置',
    bgRemovalSaveError: '无法更新去背景设置',
    bgRemovalLoadError: '无法加载去背景状态',
    limitLoadError: '无法加载手机上传限制。',
    limitSaveSuccess: '手机上传限制已保存。',
    limitSaveError: '无法保存限制。',
    accessInvalid: '请输入 0 到 9999 的整数。',
    printCopiesInvalid: '最大打印份数必须在 1 到 10 之间。',
    restartApp: '重置',
    shutdownApp: '退出应用',
    restartConfirmTitle: '重启应用？',
    restartConfirmBody: '机器应用将重启（与拔掉相机后相同）。继续？',
    shutdownConfirmTitle: '退出应用？',
    shutdownConfirmBody: '机器应用将完全关闭。继续？',
    restartSent: '重启指令已发送到机器',
    shutdownSent: '退出指令已发送到机器',
    appOfflineCantRemote: '机器离线 — 请先打开应用',
    confirmAction: '确认',
  },
  icons: {
    dropActive: '把 PNG 图标拖到这里',
    dropIdle: '把 PNG 图标拖到这里，或点击选择',
    hint: '仅 PNG，一次最多 30 个文件。超过 500KB 的文件会在上传时压缩。',
  },
};
